<template>
  <div>
    <hero-d-l
      logo="assets/img/DL_bleu-web-big.png"
      :intro="intro"
      buttonLink="/digitalleaders2023/methodology"
      buttonText="Methodology"
    />
    <categ2022 articleId="64393c06d411b5780c89bfac" :condition="categ" />
    <one-column-image-right
      slug="Digital-Leaders-in-HE-Communication-materials"
      buttonText="Download PDF"
      buttonLink="/assets/files/Press-release-2023.pdf"
    />
    <!-- <part4></part4> -->

    <!-- <dark-1-columns-image-right
      articleId="6274f20646758f0219c699a0"
      buttonText="Download PDF"
      buttonLink="/assets/files/pr2022.pdf"
    ></dark-1-columns-image-right> -->

    <!-- <one-column-image-right slug="Why-Digitalisation" /> -->
  </div>
</template>
<script>
import Categ2022 from '@/components/home/Categ2022';
import OneColumnImageRight from '@/components/common/OneColumnImageRight';
// import Part4 from '@/components/home/Part4';
// import Dark1ColumnsImageRight from '@/components/common/Dark1ColumnsImageRight';
import HeroDL from '../components/home/HeroDL2023.vue';

export default {
  components: {
    Categ2022,
    OneColumnImageRight,
    //Part4,
    // hodologyDark1ColumnsImageRight,
    HeroDL
  },
  data() {
    return {
      intro:
        'A yearly survey produced by the <a href="https://emerging.fr" target="_new">Emerging Group</a> in collaboration with <a href="https://www.trendence.com" target="_new">Trendence Institute</a> and powered by <a href="https://www.trendence.com" target="_new">Crunchbase</a> identifies which Higher Education institutions are considered as the global champions for digital education by employers worldwide.',
      categ: {
        view: 'categ2023'
      }
    };
  }
};
</script>

<style lang="scss" scoped></style>
